import React from 'react';

import { Anchor, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';

import { getSourceIcon } from './getSourceIcon.tsx';
import type { Source } from './popularQuestionsTypes.ts';

export const SourceItem = ({ source }: { source: Source }) => {
	const { title, url, iconUrl, product, description } = source;

	return (
		<Anchor href={url} rel="noopener noreferrer" xcss={styles.noUnderline}>
			<Stack space="space.075">
				<Inline alignBlock="center" space="space.100">
					{getSourceIcon({ url: iconUrl, completeKey: product })}
					<Text weight="medium" maxLines={1}>
						{title}
					</Text>
				</Inline>
				{description && (
					<Text size="small" color="color.text.subtle" maxLines={2}>
						{description}
					</Text>
				)}
			</Stack>
		</Anchor>
	);
};

const styles = cssMap({
	noUnderline: { textDecoration: 'none' },
});
